import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { RegionalService } from './shared/regional.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { Regional } from './shared/regional.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-regional',
  templateUrl: './regional.component.html',
  styleUrls: ['./regional.component.css']
})
export class RegionalComponent implements OnInit {

  datatable: any;

  ListRegional: Regional[] = [];

  constructor(
    private regionalService:RegionalService,
    private toastr:ToastrService,
    private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getRegional();
    //this.refreshList();
  }

  getRegional() {
    this.regionalService.getRegional().then(r => {
      
      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ListRegional = r as Regional[];
      
      this.chRef.detectChanges();

        const table: any = $('table');
        this.datatable = table.DataTable({
          responsive: true
        })

    });
  }

  refreshList(){
    this.regionalService.getRegional();
  }

  updateRegional(){
    this.regionalService.updateRegional().then(r =>{ this.toastr.success("Ok!");this.refreshList()});
  }
}
